import { render, staticRenderFns } from "./VendaContainer.vue?vue&type=template&id=07786b12&scoped=true"
import script from "./VendaContainer.vue?vue&type=script&lang=js"
export * from "./VendaContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07786b12",
  null
  
)

export default component.exports